import React from 'react';
import styles from './SocialLink.module.scss';
import twitterIcon from './twitter.svg';
import facebookIcon from './facebook.svg';
import instagramIcon from './instagram.svg';
import classNames from 'classnames';

const data = {
  twitter: {
    text: 'Twitter',
    icon: twitterIcon
  },
  facebook: {
    text: 'Facebook',
    icon: facebookIcon
  },
  instagram: {
    text: 'Instagram',
    icon: instagramIcon
  }
};

export default function SocialLink({ type, url }) {
  const Icon = data[type]?.icon;
  const text = data[type]?.text;

  return (
    <a
      href={url}
      className={styles.wrapper}
    >
      {Icon && <Icon className={classNames(styles.icon, type)} />}
      {text}
    </a>
  );
}
